import * as React from 'react'

/**
 * Renders a left-pointing arrow SVG icon
 * @param {object} props - Component props
 * @param {string} props.className - CSS class name for the SVG element
 * @param {Function} props.onClick - Click handler for the SVG element
 * @returns {JSX.Element} Arrow left icon SVG element
 */
function ArrowLeft(props) {
  const { className, onClick } = props
  return (
    <svg
      className={className}
      fill='none'
      height={18}
      onClick={onClick}
      viewBox='0 0 11 18'
      width={11}
    >
      <g clipPath='url(#prefix__clip0)'>
        <path
          d='M9.52 16.82L.968 9.254a.34.34 0 010-.508L9.52 1.18'
          stroke='#A8ACB3'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
        />
      </g>
      <defs>
        <clipPath id='prefix__clip0'>
          <path
            d='M0 0h10.2v17H0z'
            fill='#fff'
            transform='matrix(-1 0 0 1 10.2 .5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowLeft
